<template>
    <nav v-if="alreadyToInit">
        <pagination
            :total-items="totalItems"
            :max-visible-pages="maxVisiblePages"
            :page="page"
            :items-per-page="itemsPerPage"
            @range-change="rangeChange"
            @page-change="pageChange"
        >
            <template v-slot:buttons="props">
                <page-button
                    v-bind="button"
                    v-for="(button, key) in props.buttons"
                    :key="key"
                    @page-change="disabled ? false : (page = button.page)"
                />
            </template>
        </pagination>
    </nav>
</template>

<script>
import Pagination from '@/components/paginator/Pagination'
import PageButton from '@/components/paginator/PageButton'

export default {
    name: 'paginator',

    components: {
        PageButton,
        Pagination
    },

    props: {
        pageCount: {
            type: Number,
            default: 0
        },
        currentPage: {
            type: [String, Number]
        },
        totalItems: {
            type: Number
        },
        itemsPerPage: {
            type: Number,
            default: 25
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            start: null,
            end: null,
            maxVisiblePages: 4,
            page: 0,
            alreadyToInit: false
        }
    },

    watch: {
        $route() {
            const initPage = parseInt(this.currentPage || 1)
            this.page = parseInt(initPage) - 1

            this.alreadyToInit = true
        }
    },

    mounted() {
        const initPage = parseInt(this.currentPage || 1)
        this.page = parseInt(initPage) - 1

        this.alreadyToInit = true
    },

    methods: {
        pageChange(page) {
            if (this.disabled) return

            this.page = page
            this.$emit('pagination-change', page + 1)
        },

        rangeChange(start, end) {
            this.start = start
            this.end = end
        },

        setPage(page) {
            this.page = page
        }
    }
}
</script>

<style lang="scss">
@import '@/scss/pagination.scss';

.pagination {
    .page-item {
        cursor: pointer;

        &.active,
        &.disabled {
            cursor: default;
        }

        &:first-child {
            .page-link {
                margin-left: 0;
                border-top-left-radius: 0.25rem;
                border-bottom-left-radius: 0.25rem;
            }
        }
        &:last-child {
            .page-link {
                border-top-right-radius: 0.25rem;
                border-bottom-right-radius: 0.25rem;
            }
        }

        &.active .page-link {
            z-index: 1;
            color: var(--button-text-color) !important;
            background-color: var(--button-background-primary-color) !important;
            border-color: var(--button-background-primary-color) !important;
            pointer-events: none;
            cursor: auto;
        }

        &.disabled .page-link {
            border-color: transparent;
            background-color: white;
            opacity: 0.6;
            pointer-events: none;
            cursor: auto;
        }

        .page-link {
            color: var(--button-background-color) !important;
            border-radius: 3px;
            margin: 0 3px;
            border-color: transparent;
            background-color: var(--button-text-color) !important;
            font-weight: 600;
            transition: all 0.1s;
            box-shadow: 0 0 10px rgba(66, 66, 66, 0.1);

            &:hover {
                background-color: var(--button-background-primary-color-hover) !important;
                color: var(--button-text-color) !important;
                border-color: transparent;
            }
        }
    }
}

@media screen and (max-width: 767px) {
    .page-number {
        display: none;
    }
}
</style>
